import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from "rxjs/operators";
import { importType } from '@angular/compiler/src/output/output_ast';
import { GlobalVariable } from "src/app/globals";
import { AuthenticateService } from './authenticate.service';

@Injectable()

export class TasksService {
  private baseApiUrl = GlobalVariable.BASE_API_URL;
  constructor(
    private http: Http,
    private authService: AuthenticateService
  ) { }

  getIssueCounts(id, filterAssignedId = 0, filterProjectId = 0, filterissueType = '', filterserverityType = '', filterbugs = '', filterDate = 0, filtefurther = '') {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getIssuecounts?id=${id}&filterAssignedId=${filterAssignedId}&filterProjectId=${filterProjectId}&filterissueType=${filterissueType}&filterserverityType=${filterserverityType}&filterbugs=${filterbugs}&filterDate=${filterDate}&filtefurther=${filtefurther}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTasksCounts(id, filterAssignedId = 0, filterProjectId = 0, filterStatus = -1, filterBug = -1, filterDate = 0, sevverityStaus = '', bugstatus = '') {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/gettaskscounts?id=${id}&filterAssignedId=${filterAssignedId}&filterProjectId=${filterProjectId}&filterStatus=${filterStatus}&filterBug=${filterBug}&filterDate=${filterDate}&sevverityStaus=${sevverityStaus}&bugstatus=${bugstatus}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTaskList(pageNumber, pageSize, sortBy, sortOrder, id, filterUser, filterByUser, filterProject, filterStatus, filterBugs, filterDate, sevverityStaus, bugstatus, filterSprint = 0, filterDateFrom = '', filterDateTo = '') {
    console.log("Hello");
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&userId=${id}&filterUser=${filterUser}&filterByUser=${filterByUser}&filterProject=${filterProject}&filterStatus=${filterStatus}&filterBug=${filterBugs}&filterDate=${filterDate}&FilterSevverity=${sevverityStaus}&FilterStatusBugs=${bugstatus}&filterSprint=${filterSprint}&filterDateFrom=${filterDateFrom}&filterDateTo=${filterDateTo}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return of({ status: 'error', data: null });
      })
    );
  }

  carryForwardTask(taskId, userId) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/carryforwardtask/' + taskId;
    return this.http.put(request, { tasksId: taskId, UserId: userId }, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return of({ status: 'error', data: null }); })
    );
  }

  getAllBugsForDropdown() {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getbugsfordropdown`;
    return this.http.get(request, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return of({ status: 'error', data: [] }); })
    );
  }

  getIssueList(pageNumber, pageSize, sortBy, sortOrder, id, filterUser, filterProject, filterissueType, filterserverityType, filterbug, filterDate, search, filtefurther) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getIssues?pageNumber=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&userId=${id}&filterUser=${filterUser}&filterProject=${filterProject}&filterissueType=${filterissueType}&filterserverityType=${filterserverityType}&filterbug=${filterbug}&filterDate=${filterDate}&search=${search}&filtefurther=${filtefurther}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }


  approvedBy(Id) {
    let options = this.authService.setHeaderAuth();
    console.log('token', options);
    let request = this.baseApiUrl + 'api/tasks/approved/' + Id;
    return this.http.put(request, Id, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );

  }


  getSprintSheet() {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getSprintSheet`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }


  addBugFurther(newBugStatus) {

    let options = this.authService.setHeaderAuth();
    let requestData = {
      FurtherName: newBugStatus
    };
    console.log(requestData);
    let requestDatas = requestData.toString();

    let request = this.baseApiUrl + 'api/tasks/approved/' + newBugStatus;
    return this.http.post(request, requestData, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  
  addTask(task) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks';
    return this.http.post(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  addSprintComment(task) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/sprintCommet';
    return this.http.post(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  updateSprintComment(task) {
    console.log(task);
    let options = this.authService.setHeaderAuth();
    console.log('token', options);
    let request = this.baseApiUrl + 'api/tasks/updatesprintCommet';
    return this.http.put(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getFurther() {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/getFurther';
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTask(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/taskwithlogs/' + id;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  updateTask(task) {
    let options = this.authService.setHeaderAuth();
    console.log('token', options);
    let request = this.baseApiUrl + 'api/tasks/' + task.Id;
    return this.http.put(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }
  approvedTask(task, userId) {
    console.log(task);
    let options = this.authService.setHeaderAuth();
    let requestData = {
      tasksId: task,
      userId: userId
    };
    console.log(requestData);
    let requestDatas = requestData.toString();

    let request = this.baseApiUrl + 'api/tasks/approvedtasks/' + task;
    return this.http.put(request, requestData, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  approvedTasks(task, userId) {
    console.log(task);
    let options = this.authService.setHeaderAuth();
    let requestData = {
      tasksId: task,
      userId: userId
    };
    console.log(requestData);
    let requestDatas = requestData.toString();

    let request = this.baseApiUrl + 'api/tasks/approvedtask/' + task;
    return this.http.put(request, requestData, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  updateMarkTask(task) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/markComplete/' + task.Id;
    return this.http.put(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  deleteTask(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/' + id;
    return this.http.delete(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTaskLogs(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getlogs?id=${id}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTaskComment(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getComment?id=${id}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  addTaskLog(taskLog) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/log';
    // let headers = new Headers({ 'Content-Type': 'application/json' });
    // let options = new RequestOptions({ headers: headers });
    return this.http.post(request, taskLog, options).pipe(map(
      response => {
        return response.json()
      }
    ),
      catchError(err => {
        return "error";
      }
      ));
  }
  addTaskComment(taskLog) {
    console.log(taskLog, "taskLog")
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/comment';
    // let headers = new Headers({ 'Content-Type': 'application/json' });
    // let options = new RequestOptions({ headers: headers });
    return this.http.post(request, taskLog, options).pipe(map(
      response => {
        return response.json()
      }
    ),
      catchError(err => {
        return "error";
      }
      ));
  }
 
  addSprintRisk(taskLog) {
    console.log(taskLog, "taskLog")
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/addSprintRisk';
    // let headers = new Headers({ 'Content-Type': 'application/json' });
    // let options = new RequestOptions({ headers: headers });
    return this.http.post(request, taskLog, options).pipe(map(
      response => {
        return response.json()
      }
    ),
      catchError(err => {
        return "error";
      }
      ));
  }
   updateSprintRisk(taskLog) {
    console.log(taskLog, "taskLog")
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/updateSprintRisk';
    // let headers = new Headers({ 'Content-Type': 'application/json' });
    // let options = new RequestOptions({ headers: headers });
    return this.http.put(request, taskLog, options).pipe(map(
      response => {
        return response.json()
      }
    ),
      catchError(err => {
        return "error";
      }
      ));
  }

  getSprintRisks(taskId) {
    //console.log(id,"getSprintRisks");
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/getSprintRisks/'+ taskId;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getSprintRisksBySprint(sprintId) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/getSprintRisksBySprint/' + sprintId;
    return this.http.get(request, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return "error"; })
    );
  }

  getTaskLog(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/log/' + id;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTaskCommentById(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/comment/' + id;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  updateTaskLog(taskLog) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/log/' + taskLog.id;
    return this.http.put(request, taskLog, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  updateTaskComment(taskLog) {
    console.log(taskLog)
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/comment/' + taskLog.id;
    return this.http.put(request, taskLog, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  deleteTaskLog(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/log/' + id;
    return this.http.delete(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  deleteTaskComment(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/comment/' + id;
    return this.http.delete(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getTasksFilter(startDate, endDate) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/gettasksbydates?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getincompletetask() {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getincompletetask`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getIncompleteTaskBySprint(sprintId, userId, isAdmin) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getincompletetaskbysprint?sprintId=${sprintId}&userId=${userId}&isAdmin=${isAdmin}`;
    return this.http.get(request, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return "error"; })
    );
  }

  // getAssignTask(id) {
  //   let options = this.authService.setHeaderAuth();
  //   let request = this.baseApiUrl + `api/tasks/getassigntasks?id=${id}`;
  //   return this.http.get(request, options).pipe(
  //     map(
  //       response => {
  //         return response.json()
  //       }
  //     ),
  //     catchError(err => {
  //       return "error";
  //     }
  //     )
  //   );
  // }

  getTaskAttachments(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/files?id=${id}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  deleteTaskFile(taskId) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/deletetaskfile?id=${taskId}`;
    return this.http.delete(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getSprintSheetDetailById(Id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/getSprintSheetDetailById/' + Id;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getSprintSummary(Id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/getSprintSummary/' + Id;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }
  putSprint(task) {
    let options = this.authService.setHeaderAuth();
    console.log('token', options);
    let request = this.baseApiUrl + 'api/tasks/putSprint/' + task.id;
    return this.http.put(request, task, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }

  getNoWorkBatch(sprintId) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getNoWorkBatch/${sprintId}`;
    return this.http.get(request, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return of({ status: 'error', data: [] }); })
    );
  }

  addNoWorkBatch(entry) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + 'api/tasks/addNoWorkBatch';
    return this.http.post(request, entry, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return of({ status: 'error', data: null }); })
    );
  }

  deleteNoWorkBatch(id) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/deleteNoWorkBatch/${id}`;
    return this.http.delete(request, options).pipe(
      map(response => { return response.json() }),
      catchError(err => { return of({ status: 'error', data: null }); })
    );
  }

  getSprintSheetDetailByselectedProject(applicationId, selectedProject,selectedName) {
    let options = this.authService.setHeaderAuth();
    let request = this.baseApiUrl + `api/tasks/getselectedProject?applicationId=${applicationId}&selectedProject=${selectedProject}&selectedName=${selectedName}`;
    return this.http.get(request, options).pipe(
      map(
        response => {
          return response.json()
        }
      ),
      catchError(err => {
        return "error";
      }
      )
    );
  }
  // insertAllTasks() {
  //   let options = this.authService.setHeaderAuth();
  //   let request = this.baseApiUrl + 'api/tasks/insertalltasksindb';
  //   // let headers = new Headers({ 'Content-Type': 'application/json' });
  //   // let options = new RequestOptions({ headers: headers });
  //   return this.http.get(request, options).pipe(map(
  //     response => {
  //       return response.json()
  //     }
  //   ),
  //     catchError(err => {
  //       return "error";
  //     }
  //     ));
  // }
}
